export function Conditions() {
    return (
        <div className="bg-white shadow-md rounded md:px-8 px-4 pt-6 pb-8 md:m-4 m-1">
            <h2 className="text-2xl font-bold">Mietbedingungen</h2>

            <ul className="list-disc m-3 md:m-10 space-y-2">
                <li>
                    Vermietung ausschließlich an <b>Bewohner*innen</b> des Wohnheims Schützenweg 42.
                    Die mietende Person muss während der Veranstaltung <b>vor Ort anwesend und erreichbar</b> sein.
                </li>
                <li>
                    Ist die mietende Person nicht Bewohner*in des Wohnheims oder nicht vor Ort anwesend,
                    behalten wir uns vor, die Vermietung auch kurzfristig abzusagen bzw. zu beenden.
                    In diesem Fall kann die <b>Kaution ganz oder teilweise einbehalten</b> werden.
                </li>
                <li>Vermietung ausschließlich samstags</li>
                <li>
                    Die <b>Schlüsselübergabe</b> erfolgt samstags ab 14:00 Uhr.
                    Die Rückgabe erfolgt sonntags bis 12:00 Uhr, sofern nichts anderes abgesprochen wurde.
                </li>
                <li>
                    Die Veranstaltung muss aus Rücksicht auf die Anwohner*innen <b>spätestens um 00:30 Uhr beendet</b> sein.
                    Wir empfehlen, früh genug zu beginnen, damit ausreichend Zeit für die Veranstaltung und das Aufräumen bleibt.
                </li>
                <li>Die <b>Kühlschränke</b> werden von uns leer geräumt und können genutzt werden.</li>
                <li>Das Lager und der Raum hinter der Leinwand bleiben verschlossen und dürfen nicht genutzt werden.</li>
                <li>Bierzeltgarnituren, Sofas, Stühle, Kicker und Dartpfeile können genutzt werden.</li>
                <li><b>Miete:</b> 70€</li>
                <li>
                    <b>Kaution:</b> 100€. Die Kaution wird nach ordnungsgemäßer Rückgabe des Raums zurückgezahlt.
                    Bei Schäden, fehlender Reinigung, Verstößen gegen die Mietbedingungen oder zusätzlichem Aufwand
                    kann die Kaution ganz oder teilweise einbehalten werden.
                </li>
                <li>
                    <b>Putzoptionen</b>:
                    <ul className="list-decimal ml-6 mt-2 space-y-4">
                        {/* Ohne Putzen */}
                        <li>
                            <p>
                                <b>Ohne Putzen</b> – kostenlos
                            </p>
                            <p className="mt-1">
                                Die Mieter*innen übernehmen die vollständige Reinigung und sorgen dafür, dass der Raum so
                                hinterlassen wird, wie sie ihn vorgefunden haben.
                            </p>
                            <div className="mt-2">
                                <p className="font-semibold">Aufgaben der Mieter*innen:</p>
                                <ul className="list-disc ml-6 space-y-1">
                                    <li>Müll entsorgen (auch draußen auf der Terrasse).</li>
                                    <li>Alle Oberflächen reinigen (Tische, Thekenbereich, Sofas, Bierpongtisch).</li>
                                    <li>Gläser reinigen und einsortieren.</li>
                                    <li>Boden kehren und wischen.</li>
                                    <li>Sanitäre Anlagen (Toiletten und Waschbecken) säubern.</li>
                                    <li>Persönliche Gegenstände entfernen.</li>
                                </ul>
                            </div>
                        </li>

                        {/* Kleines Putzen */}
                        <li>
                            <p>
                                <b>Kleines Putzen</b> – 50€
                            </p>
                            <p className="mt-1">
                                Die Mieter*innen übernehmen grundlegende Reinigungsaufgaben, während das Pintenteam die
                                gründlichere Endreinigung übernimmt.
                            </p>
                            <div className="mt-2">
                                <p className="font-semibold">Aufgaben der Mieter*innen:</p>
                                <ul className="list-disc ml-6 space-y-1">
                                    <li>Müll in bereitgestellten Säcken entsorgen und Müllsäcke in die Mülltonnen bringen.</li>
                                    <li>
                                        Grobe Verschmutzungen beseitigen, z. B. verschüttete Getränke abwischen,
                                        sichtbare Essensreste entfernen und Erbrochenes aufnehmen.
                                    </li>
                                    <li>Gläser und Geschirr spülen.</li>
                                    <li>Toiletten und Waschbecken grob reinigen (z. B. sichtbaren Schmutz entfernen).</li>
                                    <li>Möbel nur in den hinteren Bereich zurückstellen, wenn der Boden dort sauber ist.</li>
                                </ul>
                            </div>
                            <div className="mt-2">
                                <p className="font-semibold">Pintenteam übernimmt:</p>
                                <ul className="list-disc ml-6 space-y-1">
                                    <li>Boden wischen und gründlich reinigen.</li>
                                    <li>Endreinigung der sanitären Anlagen.</li>
                                    <li>Gründliche Reinigung der Möbel und Oberflächen.</li>
                                    <li>Terrasse und Grill reinigen.</li>
                                </ul>
                            </div>
                        </li>

                        {/* Großes Putzen */}
                        <li>
                            <p>
                                <b>Großes Putzen</b> – 90€
                            </p>
                            <p className="mt-1">
                                Die mietende Person nimmt lediglich persönliche Gegenstände und Wertgegenstände mit.
                                Das Pintenteam übernimmt die anschließende Reinigung.
                            </p>
                            <div className="mt-2">
                                <p className="font-semibold">Aufgaben der Mieter*innen:</p>
                                <ul className="list-disc ml-6 space-y-1">
                                    <li>Persönliche Sachen mitnehmen.</li>
                                </ul>
                            </div>
                            <div className="mt-2">
                                <p className="font-semibold">Pintenteam übernimmt:</p>
                                <ul className="list-disc ml-6 space-y-1">
                                    <li>Müllentsorgung und Reinigung des gesamten Raums.</li>
                                    <li>Spülen und Verstauen der Gläser und des Geschirrs.</li>
                                    <li>Boden kehren und wischen.</li>
                                    <li>Gründliche Reinigung der sanitären Anlagen.</li>
                                    <li>Terrasse und Grill säubern.</li>
                                    <li>Entfernung aller verbleibenden Dekorationen und grober Verschmutzungen.</li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    );
}
